import constant from "../constant";
import dayjs from "dayjs";

const getTimeSlot = () => {
  const hour = dayjs().hour();
  if (hour >= 0 && hour <= 5) {
    return '凌晨';
  }
  if (hour >= 6 && hour <= 9) {
    return '早上';
  }
  if (hour >= 10 && hour <= 13) {
    return '中午';
  }
  if (hour >= 14 && hour <= 17) {
    return '下午';
  }
  if (hour >= 18 && hour <= 20) {
    return '傍晚';
  }
  if (hour >= 21 && hour <= 23) {
    return '晚上';
  }
};
const initState = {
  userName: '',
  avatar: '',
  userId: '',
  timeSlot: getTimeSlot(),
  date: dayjs().format('YYYY年MM月DD'),
  week: dayjs().format('dddd'),
  isWxBind: null,
};

export default (state = initState, action) => {
  if (action.type === constant.userInfo.SET_USER_INFO) {
    return {
      ...state,
      ...action.payload
    }
  } else if (action.type === constant.userInfo.SET_WX_BOUND) {
    return {
      ...state,
      isWxBind: action.payload
    }
  }
  return state;
}
